var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bottomTab"}},[_c('mu-container',{staticStyle:{"width":"100%"},attrs:{"color":"primary"}},[_c('mu-bottom-nav',{attrs:{"value":_vm.nowTab,"color":"#E75296"}},_vm._l((_vm.tabs),function(tab){return _c('mu-bottom-nav-item',{key:tab.tabindex,attrs:{"title":tab.name,"icon":tab.src,"to":tab.class,"value":tab.name}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }